import { ViewportType } from '../../../enums';
export const VOLUME3D_PROJECTION_ID = 'volume3d';
